// Single source of truth for classifying a factor key as forward-looking or trailing.
// Used by the visualizer UI (ControlPanel pillar-weights panel) and by the model-stats
// emitter (deck + website). If you change this, both downstream surfaces update in lockstep.

export function isForwardFactor(key: string): boolean {
  return key.startsWith('fwd')
      || key.startsWith('next')
      || key === 'pegRatio'
      || key === 'impliedBuybackYield';
}
